var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup popup-container",class:[_vm.isShow ? 'popup-show': ''],style:(_vm.popupStyle),on:{"transitionend":_vm.onTransitionEnd}},[_c('div',{staticClass:"shadow",style:(_vm.shadowStyles),on:{"click":_vm.shadowHide}}),_vm._v(" "),_c('div',{staticClass:"popup-content t-c",class:_vm.animation || 'none'},[_vm._t("default")],2),_vm._v(" "),_vm._t("second")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b11730","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup.vue
// module id = 345
// module chunks = 0